import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { map, Observable, of, take } from 'rxjs';
import { User } from 'src/app/model/user';
import { AuthService } from 'src/app/services/auth/auth.service';
import { DialogService } from 'src/app/services/dialog.service';
import { SECTIONS_PAGE } from 'src/app/Utils/globals';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly objMatDialog: MatDialog,
    private readonly translate: TranslateService,
  ) {}

  user: User;
  isTour: boolean;
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    if (state.url === '/tour') {
      return this.authService.getAppsForTourUser().pipe(
        take(1),
        map((user) => {
          return true;
        }),
      );
    }

    if (state.url === '/') {
      return of(true);
    } else {
      return this.authService.getAppsForUser().pipe(
        take(1),
        map((user) => {
          if (!user) {
            this.router.navigate(['/']);
            this.showLogoutModal();
            return false;
          }
          if (
            state.url !== `/${SECTIONS_PAGE.MAIN}` &&
            state.url !== '/readytostart' &&
            state.url !== '/onboarding'
          ) {
            const appUuid = this.getAppUuidFromUrl(state.url);
            const sectionName = this.getSectionNameFromUrl(state.url);
            if (
              appUuid === null ||
              sectionName === null ||
              !this.authService.visibleSection(sectionName) ||
              !this.authService.visibleApp(appUuid)
            ) {
              this.router.navigate([`/${SECTIONS_PAGE.MAIN}`]);
              return false;
            }
          }
          return true;
        }),
      );
    }
  }

  private getSectionNameFromUrl(url: string): string | null {
    const urlParts = url.split('/');
    const SECTION_INDEX = 2;
    if (urlParts.length > SECTION_INDEX) {
      return urlParts[SECTION_INDEX];
    }
    return null;
  }

  private getAppUuidFromUrl(url: string): string | null {
    const urlParts = url.split('/');
    const APP_UUID_INDEX = 1;
    if (urlParts.length > APP_UUID_INDEX) {
      return urlParts[APP_UUID_INDEX];
    }
    return null;
  }

  private showLogoutModal() {
    this.objMatDialog.closeAll();
    const objDialog: DialogService = new DialogService(this.objMatDialog);

    objDialog.icon = {
      src: '../../../assets/images/icons/info.svg',
      class: 'clsIcon80x80',
    };

    objDialog.texts = {
      title: this.translate.instant('logout.title'),
      main: this.translate.instant('logout.description'),
      subtext: '',
    };

    objDialog.buttons = [
      {
        btnText: 'OK',
        btnFunc: function (pThisDlg: any) {
          pThisDlg.close();
        },
      },
    ];

    objDialog.openDialog();
  }
}
